// extracted by mini-css-extract-plugin
export default {"divider":"Divider_divider__E3N1s","top":"Divider_top__UJneF"};